export default {
    jsonUrl: '/wp-content/plugins/eon-vue-filter/store/glasses.json?v=1',
    glassesBaseUrl: '/wp-content/uploads/glasses/',
    language: 'de',
    itemsperpage: 30,
    hideTitles: false,
    checkFilters: {},
    sorting: 'model_down',
    useSessionStore: false
}